<template>
  <div class="details_form_item">
    <Form ref="editModel" :model="editModel" :label-width="120">
      <FormItem label="设备SN码：">{{ editModel.clientSN }}</FormItem>
      <FormItem label="设备名称：">{{ editModel.clientName }}</FormItem>
      <FormItem label="设备类型：">{{ editModel.clientType }}</FormItem>
      <FormItem label="所属机构：">{{ editModel.organName }}</FormItem>
      <FormItem label="外网IP：">{{ editModel.publicIp }}</FormItem>
      <FormItem label="内网IP：">{{ editModel.privateIp }}</FormItem>
      <FormItem label="服务器用户名：">{{ editModel.remoteUserName }}</FormItem>

      <FormItem v-if="flag" label="服务器密码:">
        <Row>
          <Col span="20"> ****** </Col>
          <Col span="4">
            <Icon @click="flag = !flag" type="ios-eye-off-outline" size="22" />
          </Col>
        </Row>
      </FormItem>
      <FormItem v-else label="服务器密码:">
        <Row>
          <Col span="20">
            {{ editModel.remotePassword }}
          </Col>
          <Col span="4">
            <Icon @click="flag = !flag" type="ios-eye-outline" size="22" />
          </Col>
        </Row>
      </FormItem>
      <FormItem label="数据库用户名：">{{
        editModel.dataBaseUserName
      }}</FormItem>

      <FormItem v-if="dbflag" label="数据库密码：:">
        <Row>
          <Col span="20"> ****** </Col>
          <Col span="4">
            <Icon
              @click="dbflag = !dbflag"
              type="ios-eye-off-outline"
              size="22"
            />
          </Col>
        </Row>
      </FormItem>
      <FormItem v-else label="数据库密码：:">
        <Row>
          <Col span="20">
            {{ editModel.dataBasePassword }}
          </Col>
          <Col span="4">
            <Icon @click="dbflag = !dbflag" type="ios-eye-outline" size="22" />
          </Col>
        </Row>
      </FormItem>
      <FormItem label="描述信息：">{{ editModel.clientDescription }}</FormItem>
    </Form>
    <div class="ml-5 mt-5 text-center modal-foter">
      <Button @click="returnBack">关 闭</Button>
    </div>
  </div>
</template>
<script>
export default {
  props: ["currentData"],
  data: function () {
    return {
      flag: true,
      dbflag: true,
      organParentName: "",
      editModel: {},
    };
  },

  created: function () {
    this.editModel = this.currentData;
  },

  methods: {
    returnBack: function () {
      this.$emit("close");
    },
  },
};
</script>
<style scoped>
</style>